import type { EmploymentType } from '../data/types';

/**
 * The translated label for a worker type. Literal `t()` calls (rather than a
 * key map) so every label is visible to the i18n extractor and orphan
 * check. Keys live in the `wp` namespace; `t` is `useTranslation('wp').t`.
 * Mirrors `EMPLOYMENT_TYPE_KEY` (`lib/label_keys.ts`), which the CSV export
 * still uses.
 */
export function employment_type_label(
  t: (key: string) => string,
  type: EmploymentType,
): string {
  switch (type) {
    case 'full_time':
      return t('employment_type.full_time');
    case 'part_time':
      return t('employment_type.part_time');
    case 'contract':
      return t('employment_type.contract');
    case 'contractor':
      return t('employment_type.contractor');
  }
}
